var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlr = function SvgBlr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75AF2B",
    d: "M.6.2H512v341H.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D32424",
    d: "M0 230h512V.2H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M100.1 230V.2H0v340.9h511.4-411.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D32424",
    d: "M51.6 218l-38-47.7 38-46.9 38 46.9zm0-104.6l-38-47.7 38-46.9 38 46.9zm0 209.2l-38-47.7 38-46.9 38 46.9z"
  })));
};
export { SvgBlr as ReactComponent };